module.exports = __webpack_public_path__ + "0b83d2022f73afcd8edfb8391a1725e6.jpg";